export enum FeatureKey {
  AccountAccess = 'account-access',
  Cards = 'cards',
  Transfers = 'transfers',
  SupplementaryFunctionalities = 'supplementary-functionalities',
  Support = 'support',
  GuarantyAndInsurance = 'guaranty-and-insurance',
  InvoicingTool = 'invoicing-tool',
}

interface Row {
  isActive: boolean;
  label: string;
  isNew?: boolean;
}

export interface Feature {
  key: FeatureKey;
  rows: Row[];
}
